import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { getStorageSafely, StorageType } from "../helpers";
export { useQuery } from "@tanstack/react-query";

export interface HttpError extends Error {
  status: number;
  body?: unknown;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      retry: (failures, err) => ((err as HttpError).status === 403 ? false : failures < 3),
    },
  },
});

export const setupQueryClientPersistence = ({ storageType, buster }: { storageType: StorageType; buster: string }) => {
  const storage = getStorageSafely(storageType);
  if (!storage) return;

  const [, restorePromise] = persistQueryClient({
    queryClient,
    persister: createAsyncStoragePersister({ storage }),
    buster,
  });

  void restorePromise.then(() => queryClient.invalidateQueries());
};
